export default __webpack_public_path__ + "static/media/menu-organization.741bf124.svg";